import React from 'react';
import { useNavigate } from "react-router-dom";

import { Container } from './styles';

const CancelLink = (props) => {
    const navigate = useNavigate();

    return (
        <Container type="button" onClick={() => navigate(-1)}>
           { props.desc != null ? props.desc : "Cancel"}
        </Container>
    );
}

export default CancelLink;
